import * as types from '../types'

// key: "calendar" (month grid) or "day:YYYY-MM-DD" (Daily sidebar).
// filters: { status?, target_objects? }
export const getEventList = (key, start, end, filters = {}, loadMoreData = false) => (
  { type: types.EVENT_ACTION_GET_EVENT_LIST, key, start, end, filters, loadMoreData }
)

export const refreshEventLists = () => ({ type: types.EVENT_ACTION_REFRESH_LISTS })

// Silent re-fetch of one event's detail — no loading flag, and a failed request leaves the record
// already in the store untouched (getEvent below is for opening the detail: a non-404 failure
// there would overwrite the record with an empty one).
export const refreshEvent = (eventKey) => (
  { type: types.EVENT_ACTION_REFRESH_EVENT, eventKey }
)

export const getEvent = (eventKey) => (
  { type: types.EVENT_ACTION_GET_EVENT, eventKey }
)

export const createEvent = (data, completeCallback) => (
  { type: types.EVENT_ACTION_CREATE_EVENT, data, completeCallback }
)

export const updateEvent = (eventKey, data, completeCallback) => (
  { type: types.EVENT_ACTION_UPDATE_EVENT, eventKey, data, completeCallback }
)

export const deleteEvent = (eventKey, completeCallback) => (
  { type: types.EVENT_ACTION_DELETE_EVENT, eventKey, completeCallback }
)
